module.exports = __webpack_public_path__ + "dcb5b8ca30bca514f31533d0084c3204.jpg";